import React, { useState } from "react";

import CalendarTooltip from "./CalendarTooltip";

const getColor = (score) => {
  if (!score) return "bg-gray-800";

  if (score >= 9) return "bg-emerald-500";

  if (score >= 7) return "bg-green-500";

  if (score >= 5) return "bg-yellow-500";

  return "bg-red-500";
};

export default function CalendarDay({ date, data, onClick }) {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!date) {
    return <div className="h-24" />;
  }

  return (
    <div
      className="relative"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <button
        onClick={() => onClick && onClick(date)}
        className={`
                h-24
                rounded-xl
                border
                border-gray-700
                p-2
                text-left
                transition
                hover:scale-105
                ${getColor(data?.averageScore)}
            `}
      >
        <div className="text-xs text-white opacity-80">{date.getDate()}</div>

        {data && (
          <>
            <div
              className="
                    text-xl
                    font-bold
                    text-white
                    mt-2
                "
            >
              {data.averageScore}
            </div>

            <div className="text-xs text-white">{data.activities} Act</div>
          </>
        )}
      </button>

      {showTooltip && data && <CalendarTooltip data={data} date={date} />}
    </div>
  );
}
